<template>
  <div class="drug-info-wrapper">
    <div class="drug-rp">Rp.</div>
    <west-drug v-if="data.prescriptionType === 0" :drug-list="data.drugList" />
    <chinese-drug v-else :drug-list="data.drugList" :chinese-drug-model="data.chineseDrugModel" />
    <div v-if="data.supplementaryNotes" class="drug-additional-information">
      补充说明：{{ data.supplementaryNotes }}
    </div>
    <div class="drug-empty">以下空白</div>
  </div>
</template>

<script>
import westDrug from './westDrug.vue';
import chineseDrug from './chineseDrug.vue';
export default {
  name: 'DrugInfo',
  components: {
    westDrug,
    chineseDrug
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped lang="scss">
.drug-info-wrapper {
  padding: 12pt 0;
  border-bottom: 1pt solid #000;

  .drug-rp {
    margin-bottom: 8pt;
    font-size: 14pt;
    font-weight: 600;
    color: #000;
  }

  .drug-additional-information {
    margin-bottom: 12pt;
    font-size: 10pt;
    line-height: 1.4;
    color: #000;
  }

  .drug-empty {
    position: relative;
    display: flex;
    align-items: center;
    gap: 14pt;
    font-size: 8pt;
    font-weight: 500;
    color: #000;

    &:before,
    &:after {
      content: '';
      flex: 1;
      border-bottom: 1pt dashed #000;
    }
  }
}
</style>
